export default __webpack_public_path__ + "static/media/m-kharcho.d3316426.png";